import React from "react";
import { Star } from "lucide-react";
import "./Testimonials.css";

const testimonials = [
  {
    quote:
      "I was nervous about selling my mother's old jewellery, but Durga Gold showed me every reading on screen. Fair price, cash in minutes.",
    name: "Lakshmi R.",
    location: "T. Nagar, Chennai",
  },
  {
    quote:
      "The most transparent gold buyers I've dealt with. No hidden deductions, no pressure. Highly recommend.",
    name: "Karthik S.",
    location: "Adyar, Chennai",
  },
  {
    quote:
      "Quick evaluation and instant payment. The testing machine gave me confidence the purity reading was honest.",
    name: "Fathima A.",
    location: "Mylapore, Chennai",
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials" id="reviews">
      <div className="testimonials__intro">
        <span className="testimonials__eyebrow">
          <span className="testimonials__eyebrow-line" />
          Happy Customers
        </span>

        <h2 className="testimonials__headline">
          Trust, <span className="testimonials__highlight">witnessed</span>
          <br />
          by thousands.
        </h2>

        <div className="testimonials__rating">
          <div className="testimonials__stars">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="testimonials__star" />
            ))}
          </div>
          <span className="testimonials__rating-text">
            4.9 average · Loved across Chennai
          </span>
        </div>
      </div>

      <div className="testimonials__list">
        {testimonials.map((t, i) => (
          <div className="testimonials__card" key={i}>
            <p className="testimonials__quote">&ldquo;{t.quote}&rdquo;</p>
            <p className="testimonials__author">
              <span className="testimonials__name">{t.name}</span>
              <span className="testimonials__dot"> · </span>
              <span className="testimonials__location">{t.location}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
